export enum loginby {
    superAdmin=0,
    dealer=1
}